import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function resolveBackendUrl() {
  // Always use deployed backend on Render (no trailing slash)
  return "https://asteroid-mining-platform-backend.onrender.com";
}
